export default "__VITE_PUBLIC_ASSET__b1bc5775__"